import React, {FunctionComponent} from 'react';
import SubjectArea from '../../../../networking/models/SubjectArea';
import EditCard from '../../layout/EditCard';

interface Props {
    subjectArea: SubjectArea;
    onChange: (subjectArea: SubjectArea) => void;
    onDelete: (subjectArea: SubjectArea) => void;
}

const SubjectAreaCard: FunctionComponent<Props> = ({ subjectArea, onChange, onDelete }) => {

    const onNameChange = (name: string) => {
        onChange({ ...subjectArea, name });
    };

    const onAreaDelete = () => onDelete(subjectArea);

    return (
        <EditCard value={subjectArea.name} onChange={onNameChange} onDelete={onAreaDelete} />
    );
};

export default SubjectAreaCard;
